import { GrupoCampoAnalise, StatusItemAnalise, } from '../enums/analise.enum';
export function getStatusEntidade(entidade, gruposCampos) {
    var statusMap = {};
    if (!gruposCampos) {
        return statusMap;
    }
    var gruposFiltrados = gruposCampos.filter(function (grupo) { return grupo.entidade === entidade; });
    var gruposPorEntidade = gruposFiltrados.reduce(function (acc, grupo) {
        if (!acc[grupo.entidadeAssociadaId]) {
            acc[grupo.entidadeAssociadaId] = [];
        }
        acc[grupo.entidadeAssociadaId].push(grupo);
        return acc;
    }, {});
    Object.entries(gruposPorEntidade).forEach(function (_a) {
        var entidadeId = _a[0], grupos = _a[1];
        var hasReprovado = grupos.some(function (grupo) { return grupo.status !== StatusItemAnalise.APROVADO; });
        statusMap[Number(entidadeId)] = hasReprovado
            ? StatusItemAnalise.REPROVADO
            : StatusItemAnalise.APROVADO;
    });
    return statusMap;
}
export function getDisabledFlags(entidade, entidadeAssociadaId, gruposCampos, disabled) {
    if (!entidadeAssociadaId || disabled) {
        return {
            disabledDadosGerais: disabled,
            disabledContato: disabled,
            disabledEndereco: disabled,
        };
    }
    var disabledDadosGerais = !!(gruposCampos === null || gruposCampos === void 0 ? void 0 : gruposCampos.some(function (grupo) {
        return grupo.grupo === GrupoCampoAnalise.DADOS_GERAIS &&
            grupo.entidadeAssociadaId === entidadeAssociadaId &&
            grupo.entidade === entidade &&
            grupo.status === StatusItemAnalise.APROVADO;
    }));
    var disabledContato = !!(gruposCampos === null || gruposCampos === void 0 ? void 0 : gruposCampos.some(function (grupo) {
        return grupo.grupo === GrupoCampoAnalise.CONTATO &&
            grupo.entidadeAssociadaId === entidadeAssociadaId &&
            grupo.entidade === entidade &&
            grupo.status === StatusItemAnalise.APROVADO;
    }));
    var disabledEndereco = !!(gruposCampos === null || gruposCampos === void 0 ? void 0 : gruposCampos.some(function (grupo) {
        return grupo.grupo === GrupoCampoAnalise.ENDERECO &&
            grupo.entidadeAssociadaId === entidadeAssociadaId &&
            grupo.entidade === entidade &&
            grupo.status === StatusItemAnalise.APROVADO;
    }));
    return {
        disabledDadosGerais: disabledDadosGerais,
        disabledContato: disabledContato,
        disabledEndereco: disabledEndereco,
    };
}
export function getStatusAnaliseEntity(entidade, entidadeId, gruposCampos, analiseDocumentos, documentos) {
    var statusGrupoCampos = getStatusAnaliseEntityGrupo(entidade, entidadeId, gruposCampos);
    var statusDocumentos = getStatusAnaliseEntityDocumentos(documentos, analiseDocumentos);
    if (statusGrupoCampos === StatusItemAnalise.REPROVADO ||
        statusDocumentos === StatusItemAnalise.REPROVADO) {
        return StatusItemAnalise.REPROVADO;
    }
    if (statusGrupoCampos === StatusItemAnalise.APROVADO ||
        statusDocumentos === StatusItemAnalise.APROVADO) {
        return StatusItemAnalise.APROVADO;
    }
    return StatusItemAnalise.NAO_ANALISADO;
}
function getStatusAnaliseEntityGrupo(entidade, entidadeAssociadaId, gruposCampos) {
    var temReprovado = gruposCampos === null || gruposCampos === void 0 ? void 0 : gruposCampos.some(function (campo) {
        return campo.entidade === entidade &&
            campo.entidadeAssociadaId === entidadeAssociadaId &&
            campo.status === StatusItemAnalise.REPROVADO;
    });
    var temAprovado = gruposCampos === null || gruposCampos === void 0 ? void 0 : gruposCampos.some(function (campo) {
        return campo.entidade === entidade &&
            campo.entidadeAssociadaId === entidadeAssociadaId &&
            campo.status === StatusItemAnalise.APROVADO;
    });
    if (temReprovado) {
        return StatusItemAnalise.REPROVADO;
    }
    if (temAprovado) {
        return StatusItemAnalise.APROVADO;
    }
    return StatusItemAnalise.NAO_ANALISADO;
}
function getStatusAnaliseEntityDocumentos(documentos, analiseDocumentos) {
    var temReprovado = documentos === null || documentos === void 0 ? void 0 : documentos.some(function (doc) {
        return analiseDocumentos === null || analiseDocumentos === void 0 ? void 0 : analiseDocumentos.some(function (analise) {
            return analise.documentoId === doc.id &&
                analise.status === StatusItemAnalise.REPROVADO;
        });
    });
    var temAprovado = documentos === null || documentos === void 0 ? void 0 : documentos.some(function (doc) {
        return analiseDocumentos === null || analiseDocumentos === void 0 ? void 0 : analiseDocumentos.some(function (analise) {
            return analise.documentoId === doc.id &&
                analise.status === StatusItemAnalise.APROVADO;
        });
    });
    if (temReprovado) {
        return StatusItemAnalise.REPROVADO;
    }
    if (temAprovado) {
        return StatusItemAnalise.APROVADO;
    }
    return StatusItemAnalise.NAO_ANALISADO;
}
